
<div class="w-full pr-10 flex flex-col gap-6 overflow-hidden">
  <form >
    <div class="bg-white rounded-xl p-4 flex items-center gap-4">
      <div class="flex items-center gap-2 w-full">
        <img src="../../assets/image/search.svg" alt="" class="" />
        <input
          placeholder="Search Concern Type  Here..."
          class="w-full border p-2 rounded-md outline-none"
          
          placeholder="Search ...." matInput (input)="applyFilter($event)"
        />
      </div>
      <div class="w-80">
        
      </div>
     
      <div class="w-60" >
        <app-primary-button routerLink="/home/add-monthly-billing" class="flex w-40">
          <div class="flex space-x-2">
            <img src="../../../../assets/image/+.svg" alt="" />
            <span>Add </span>
          </div>
        </app-primary-button>
      </div>
    </div>
  </form>
  <div class="bg-white rounded-2xl shadow-md p-4">

  <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 w-full">

    <ng-container matColumnDef="module">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Module</th>
      <td mat-cell *matCellDef="let element">{{ element.module }}</td>
    </ng-container>

    <ng-container matColumnDef="features">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Features</th>
      <td mat-cell *matCellDef="let element">{{ stringify(element.features) }}</td>
    </ng-container>

    <ng-container matColumnDef="forms">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Forms</th>
      <td mat-cell *matCellDef="let element">{{ stringify(element.forms) }}</td>
    </ng-container>

    <ng-container matColumnDef="systemAction">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>System Action</th>
      <td mat-cell *matCellDef="let element">{{ stringify(element.systemAction) }}</td>
    </ng-container>

    <ng-container matColumnDef="benefits">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Benefits</th>
      <td mat-cell *matCellDef="let element">{{ stringify(element.benefits) }}</td>
    </ng-container>

    <ng-container matColumnDef="kpi">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>KPI</th>
      <td mat-cell *matCellDef="let element">{{ element.kpi }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons class="p-2 rounded-md"></mat-paginator>
  </div>
</div>

